import styled from 'styled-components'

// Utils
import { breakpoint } from '@sketch/global-styles'
import {
  BannerCard,
  BannerCardBodyContainer,
  BannerCardTitle,
  BannerCardActionContainer,
} from '@sketch/components'

export const Wrapper = styled.div`
  display: flex;
  max-width: 1160px;
  margin: 0 0 40px 0;
  flex: 0;

  ${breakpoint('base', 'xl')`
    flex-wrap: wrap;
  `}
`

export const Icon = styled.svg`
  width: 48px;
  height: 48px;
`

export const StyledBannerCard = styled(BannerCard)`
  &:not(:last-child) {
    margin-right: 40px;
  }

  ${breakpoint('md', 'lg')`
        flex-direction: row;
        flex: 1 1 44%;
        max-width: 100%;
    `}

  ${breakpoint('sm', 'md')`
        flex: 1 1 44%;
        max-width: 100%;
    `}

    ${breakpoint('xs', 'sm')`
        flex: 1 1 44%;
        max-width: 100%;
    `}

    ${breakpoint('base', 'lg')`
        &:not(:last-child) {
          margin-right: 0;
        }

        &:nth-child(n+3) {
          margin-top: 40px;
        }

        &:not(:nth-child(2n)) {
          margin-right: 40px;
        }
    `}

    ${breakpoint('base', 'md')`
      &:nth-child(n+3) {
        margin-top: 16px;
      }

      &:not(:nth-child(2n)) {
        margin-right: 16px;
      }
    `}

    ${breakpoint('base', 'xs')`
        flex-direction: row;
        flex: 1 1 100%;
        max-width: 100%;

        &:not(:first-child) {
          margin-top: 16px;
        }

        &:not(:nth-child(2n)) {
         margin-right: 0;
        }
    `}

    ${BannerCardBodyContainer} {
    ${breakpoint('md', 'lg')`
        margin-left: 16px;
      `}

    ${breakpoint('base', 'xs')`
        margin-left: 16px;
      `}
  }

  ${BannerCardTitle} {
    ${breakpoint('md', 'lg')`
        margin: 0;
      `}

    ${breakpoint('base', 'xs')`
        margin: 0;
      `}
  }

  ${BannerCardActionContainer} {
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    justify-content: flex-end;

    ${breakpoint('md', 'lg')`
      align-items: flex-start;
    `}
  }
`
